import { render, staticRenderFns } from "./ner-analyser.html?vue&type=template&id=78a2fb22&scoped=true&"
import script from "./ner-analyser.js?vue&type=script&lang=js&"
export * from "./ner-analyser.js?vue&type=script&lang=js&"
import style0 from "./ner-analyser.scss?vue&type=style&index=0&id=78a2fb22&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a2fb22",
  null
  
)

export default component.exports